.root {
    margin: 1.25rem 0;
}

/* 4a + 4d: transparent on the white article column, slightly larger
   radius, lighter grey border. Light-gray fill when expanded. */
.item {
    border: 1px solid #dee2e6;
    border-radius: 7.5px;
    background-color: transparent;
}

.item[data-active="true"] {
    background-color: #f8f9fa;
}

/* 4d: dibdev — 0 top/bottom, 15px left/right. */
.control {
    padding: 0 15px;
}

.controlInner {
    display: flex;
    flex-direction: column;
}

/* 4b: Lato, 15px / 700 / #333. */
.title {
    font-family: Lato, sans-serif;
    font-size: 0.9375rem;
    font-weight: 700;
    color: #333;
}

/* 4c: subtitles — visibility toggled by Mantine's data-active on .item. */
.subtitleMore,
.subtitleLess {
    font-family: Lato, sans-serif;
    font-size: 0.8203rem;
    font-weight: 400;
    color: #868e96;
}

.subtitleMore {
    display: block;
}

.subtitleLess {
    display: none;
}

.item[data-active="true"] .subtitleMore {
    display: none;
}

.item[data-active="true"] .subtitleLess {
    display: block;
}

.panel {
}

/* dibdev — 4.6875px top, 15px right/bottom/left. */
.content {
    padding: 4.6875px 15px 15px 15px;
    font-size: 0.9375rem;
}

.content p {
    margin-bottom: 0.625rem;
}

.content p:last-child {
    margin-bottom: 0;
}

.content table {
    margin: 0.5rem 0;
}
